/*
  Reviews.io renders its star ratings once on page load. Product cards, however, are re-rendered
  by theme AJAX (filters, sorting, pagination) and by the Boost collection controller, so any new
  .ruk_rating_snippet placeholder would stay empty. This script re-runs Reviews.io for those.

  The script itself (rating-snippet/dist.js) and the store settings come from the Reviews.io app
  embed - nothing is loaded here.
*/
(function () {
  const SNIPPET_CLASS = 'ruk_rating_snippet';
  const RETRY_DELAY = 300;
  const MAX_RETRIES = 40;

  let debounceTimer = null;
  let retryTimer = null;
  let retries = 0;

  function snippetOptions() {
    const store = window.__REVIEWSIO_RATING_SNIPPET_STORE_OVERRIDE__ || window.reviewsIoStore;
    if (!store) return null;

    // Same options as the Reviews.io app embed so stars look identical across the store.
    return {
      store: store,
      color: '#241065',
      textClr: '#241065',
      linebreak: false,
      lang: window.reviewsIoLang || 'en',
      mode: 'default',
      showEmptyStars: true,
      enableSyndication: window.reviewsIoEnableSyndication || false,
    };
  }

  function render() {
    const options = snippetOptions();
    if (!options || !document.querySelector('.' + SNIPPET_CLASS + ':empty')) return;

    // The app embed script may not have executed yet; keep a single retry chain waiting for it.
    if (typeof window.ratingSnippet !== 'function') {
      if (retryTimer || retries >= MAX_RETRIES) return;
      retries += 1;
      retryTimer = window.setTimeout(() => {
        retryTimer = null;
        render();
      }, RETRY_DELAY);
      return;
    }

    window.ratingSnippet(SNIPPET_CLASS, options);
  }

  function schedule() {
    retries = 0;
    window.clearTimeout(debounceTimer);
    debounceTimer = window.setTimeout(render, 150);
  }

  window.renderReviewsIoRatings = schedule;

  new MutationObserver((mutations) => {
    const addedSnippet = mutations.some((mutation) => Array.from(mutation.addedNodes).some((node) => (
      node.nodeType === 1
      && (node.classList.contains(SNIPPET_CLASS) || node.querySelector('.' + SNIPPET_CLASS))
    )));
    if (addedSnippet) schedule();
  }).observe(document.documentElement, { childList: true, subtree: true });

  window.addEventListener('load', schedule);
  schedule();
}());
